export const locationStringUnderscore = (array: (string | number)[]): string =>
  String(array.join('_'))
